import React from "react";
import classNames from "classnames";

import styles from "./Header.module.scss";

const Header = ({ type, element }) => {
  const titleAttr = ({ item, lngs = ["fr", "en", "nl"], lang }) => {
    if (type === "ARTICLE") {
      return element.title;
    }

    if (lang) {
      let val = `title${lang.charAt(0).toUpperCase() + lang.slice(1)}`;
      if (item[val] && item[val].length === 0 && lang.length > 0) {
        return titleAttr({
          item,
          lngs: lngs.filter((el) => el !== lang),
          lang: lngs[0],
        });
      }
      return item[val];
    }
    return "";
  };

  const chain = () => {
    switch (type) {
      case "RUBRIC":
        return element.chain && element.chain[0].mediaChain
          ? element.chain[0].mediaChain[0].avatarUrl
          : null;
      case "ARTICLE":
        return element.chains && element.chains[0].mediaChain
          ? element.chains[0].mediaChain[0].avatarUrl
          : null;
      default:
        return null;
    }
  };

  return (
    // <div className="header-container">
    <div className={classNames(styles.header_container, styles.widget)}>
      <div className={styles.content}>
        <div className={styles.top}>
          <div
            className={styles.type}
            style={{
              color: type === "ARTICLE" ? "#4D949D" : "#2E89C7",
            }}
          >
            {[type.toLowerCase()]}
          </div>

          {chain() && (
            <div
              className={styles.chain}
              style={{ backgroundImage: `url(${chain()})` }}
            ></div>
          )}
        </div>
        <div className={styles.title}>
          {titleAttr({ item: element, lang: "fr" })}
        </div>
      </div>
    </div>
    // </div>
  );
};

export default Header;
